// extracted by mini-css-extract-plugin
export default {"modalButtonWrapper":"styles_modalButtonWrapper__DRhet"};